import React from "react";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

const RenderTool = ({ imgSrc, title, desc }) => (
  <div className="item mb-30 flex">
    <div className="img">
      <img src={imgSrc} alt={title} />
    </div>
    <div className="flex flex-column">
      <h6 className="fz-18 item-title ml-10 text-align-left">{title}</h6>
      <h6 className="fz-14 mt-20 ml-10 text-align-left">{desc}</h6>
    </div>
  </div>
);

function Skills() {
  const swiperOptions = {
    modules: [Pagination, Navigation],
    spaceBetween: 30,
    loop: true,
    pagination: {
      el: ".skills-container .swiper-pagination",
      clickable: true,
    },

    navigation: {
      nextEl: ".skills-container .swiper-button-next",
      prevEl: ".skills-container .swiper-button-prev",
    },
  };
  return (
    <section className="my-skills section-padding skills-container">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-6 col-md-10">
            <div className="sec-head text-center mb-80">
              <h3>Empowering Design Through Industry Leading Tools.</h3>
            </div>
          </div>
        </div>
        <div className="position-re">
          <div
            className="testim-swiper"
            data-carousel="swiper"
            data-loop="true"
            data-space="30"
          >
            <Swiper
              {...swiperOptions}
              id="content-carousel-container-unq-testim"
              className="swiper-container"
              data-swiper="container"
            >
              <SwiperSlide style={{ padding: 0 }}>
                <div className="item">
                  <div className="row md-marg">
                    <div className="item-tool col-lg-4 col-md-4 col-6">
                      <RenderTool
                        imgSrc="/assets/imgs/resume/s1.png"
                        title="Figma"
                        desc="Design"
                      />
                    </div>
                    <div className="item-tool col-lg-4 col-md-4 col-6">
                      <RenderTool
                        imgSrc="/assets/imgs/resume/s2.png"
                        title="Adobe XD"
                        desc="Design"
                      />
                    </div>
                    <div className="item-tool col-lg-4 col-md-4 col-6">
                      <RenderTool
                        imgSrc="/assets/imgs/resume/s7.png"
                        title="Sketch"
                        desc="Design"
                      />
                    </div>
                    <div className="item-tool col-lg-4 col-md-4 col-6">
                      <RenderTool
                        imgSrc="/assets/imgs/resume/s4.png"
                        title="Miro"
                        desc="Design"
                      />
                    </div>
                    <div className="item-tool col-lg-4 col-md-4 col-6">
                      <RenderTool
                        imgSrc="/assets/imgs/resume/s5.png"
                        title="Google Analytics"
                        desc="Analytics"
                      />
                    </div>
                    <div className="item-tool col-lg-4 col-md-4 col-6">
                      <RenderTool
                        imgSrc="/assets/imgs/resume/s3.png"
                        title="Storybook"
                        desc="Development"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide style={{ padding: 0 }}>
                <div className="item">
                  <div className="row md-marg">
                    <div className="item-tool col-lg-4 col-md-4 col-6">
                      <RenderTool
                        imgSrc="/assets/imgs/resume/s8.png"
                        title="Balsamiq"
                        desc="Wireframe"
                      />
                    </div>
                    <div className="item-tool col-lg-4 col-md-4 col-6">
                      <RenderTool
                        imgSrc="/assets/imgs/resume/s9.png"
                        title="Lucid chart"
                        desc="Visual Diagrams"
                      />
                    </div>
                    <div className="item-tool col-lg-4 col-md-4 col-6">
                      <RenderTool
                        imgSrc="/assets/imgs/resume/s10.png"
                        title="Hotjar"
                        desc="Visual Analytics"
                      />
                    </div>
                    <div className="item-tool col-lg-4 col-md-4 col-6">
                      <RenderTool
                        imgSrc="/assets/imgs/resume/s11.png"
                        title="Qualtrics"
                        desc="Surveys"
                      />
                    </div>
                    <div className="item-tool col-lg-4 col-md-4 col-6">
                      <RenderTool
                        imgSrc="/assets/imgs/resume/s12.png"
                        title="lookback"
                        desc="Research"
                      />
                    </div>
                    <div className="item-tool col-lg-4 col-md-4 col-6">
                      <RenderTool
                        imgSrc="/assets/imgs/resume/s13.png"
                        title="Zeplin"
                        desc="Handoff"
                      />
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </div>
          <div className="swiper-arrow-control control-abslout justify-end">
            <div className="swiper-button-prev">
              <span className="ti-arrow-left"></span>
            </div>
            <div className="swiper-button-next">
              <span className="ti-arrow-right"></span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Skills;
